import { useContext } from "react";
import { dataContext } from "../context/context";

import Finance from '../components/sections/finance/finance';
import Lump from '../components/sections/lump/lump';
import Formats from '../components/sections/formats/formats';
import Regions from '../components/sections/regions/regions';
import Cases from '../components/sections/cases/cases';
import Contacts from '../components/sections/contacts/contacts';
import Why from '../components/sections/why/why';
import Growth from '../components/sections/growth/growth';

import loadingIcon from "../assets/images/loading.svg";
import errorIcon from "../assets/images/error.svg";


export const Page = () => {

    const { data, loading, error, isBY, isRU, isLocal  } = useContext(dataContext);

    if (loading) return (

        <main id="loading">
            <section>
                <div className="inner_block">

                    <h2><img src={loadingIcon} /> Загрузка...</h2>

                </div>
            </section>
        </main>

    );

    else if (!data || error) return (

        <main id="error">
            <section>
                <div className="inner_block">

                    <h2><img src={errorIcon} /> Ошибка загрузки!</h2>

                </div>
            </section>
        </main>


    );

    else return (
        <main>
            <Finance />
            <Lump />
            <Formats />
            <Regions />
            <Cases />
            <Contacts />
            <Why />
            <Growth />
        </main>
    )
}